import {
    GetPositionProductGroupsResponseSchema,
    GetPositionResponseSchema,
    GetPositionsBySalesforceOpportunityIdSchema,
} from '@schuettflix/interfaces';
import { z } from 'zod';
import { useHttpClientContext } from '@/shared/context/HttpClientContext.tsx';

export const useGetPositionById = () => {
    const { positionClient } = useHttpClientContext();
    return {
        getPositionById: (positionId: string) =>
            positionClient
                .get<z.input<typeof GetPositionResponseSchema>>(`/v1/position/${positionId}`)
                .then(res => GetPositionResponseSchema.parse(res.data)),
    };
};

export const useGetPositionsMappedToSalesforceOpportunityLineItemIdByOpportunityId = () => {
    const { positionClient } = useHttpClientContext();
    return {
        getPositionsMappedToSalesforceOpportunityLineItemIdByOpportunityId: ({
            salesforceOpportunityId,
        }: {
            salesforceOpportunityId: string;
        }) =>
            positionClient
                .get<
                    z.input<typeof GetPositionsBySalesforceOpportunityIdSchema>
                >(`/v1/positions/deal/${salesforceOpportunityId}`)
                .then(res => GetPositionsBySalesforceOpportunityIdSchema.parse(res.data)),
    };
};

export const useGetPositionProductGroups = () => {
    const { positionClient } = useHttpClientContext();
    return {
        getPositionProductGroups: (positionId: string) =>
            positionClient
                .get<z.input<typeof GetPositionProductGroupsResponseSchema>>(`/v1/position/${positionId}/product-group`)
                .then(res => GetPositionProductGroupsResponseSchema.parse(res.data)),
    };
};
